<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Confirmação da ação de excluir produto</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>
      <div class="c-modalCard__body">
        Deletar o produto fará com que ele não possa ser anunciado no marketplace e impedirá que o anúncio seja atualizado caso já esteja rodando, certifique-se de deletar o anúncio diretamente no marketplace.
      </div>
      <div class="c-modalCard__body">
        Tem certeza de que deseja excluir o produto {{ productInText }}?
      </div>
      <div class="c-modalCard__body">
        <div class="l-row">
          <form-group v-if="reasons" label="Motivo para exclusão" class="l-col-12@md" :required="true">
            <select v-model="reason" class="form-select">
              <option :value=null>{{ $t('choose.label') }} </option>
              <option v-for="reasonValue in reasons" :key="reasonValue" :value="reasonValue">{{ reasonValue }}</option>
            </select>
          </form-group>
        </div>
      </div>
      <footer class="c-modalCard__footer">
        <button type="button" class="btn" v-on:click="cancel()">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api/marketplace/cnova'
  import notifier from '@/notifier'
  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      reasons: [
        'Edição de produto',
        'Erro de integração',
        'Troca de integradora'
      ]
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      product: {
        type: Object,
        required: false
      },
      typeAction: {
        type: String,
        required: false
      },
      reason: {
        type: String,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    async mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      async confirm () {
        if (this.reason === undefined || this.reason === null) {
          notifier.error('Selecione o motivo para exclusão', 'Erro')
          return false
        }
        await api.deleteProduct(this.product, this.reason)
          .then((data) => {
            this.product.status = data.status
            notifier.success('Solicitação de exclusão realizada com sucesso.', 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao enviar produto para exclusão.'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.$emit('option', true)
            this.close()
          })
        return false
      },
      cancel () {
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      }
    },
    computed: {
      productInText () {
        if (this.product === null) {
          return null
        }
        return `'${this.product.title}'`
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    },
    components: {
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// ModalDeleteProduct.vue?031ec98c